import React from 'react'

import { Table } from '_zari/core'

import {
  AfectacionesCompraConstant,
  OrigenesContabilidadConstant,
  AfectacionesVentaConstant
} from 'constants/index'

const tableHeaderRows = [
  { label: 'IMPORTE' },
  { label: 'CUENTA CONTABLE' },
  { label: 'AFECTACION' },
  { label: 'CENTRO COSTO' },
  { label: 'CUENTA DESTINO' },
  { label: '' }
]

const DetalleTablaSection = ({ iOrigen, detalles, dispatch }) => {
  const clickEliminar = React.useCallback(
    ({ _idFila }) => {
      dispatch({ type: 'eliminar', payload: { _idFila } })
    },
    [dispatch]
  )

  const tableRowTemplate = React.useCallback(
    row => (
      <Table.Row key={row._idFila}>
        <Table.Cell align='center'>{row.importe ? row.importe.toFixed(2) : '0.00'}</Table.Cell>
        <Table.Cell>{row.cuentaContableInfo || '--'}</Table.Cell>
        <Table.Cell align='center'>
          {row.tipoAfectacion
            ? iOrigen === OrigenesContabilidadConstant.VENTAS
              ? AfectacionesVentaConstant.__dictionary[row.tipoAfectacion].nombre
              : AfectacionesCompraConstant.__dictionary[row.tipoAfectacion].nombre
            : '--'}
        </Table.Cell>
        <Table.Cell align='center'>{row.centroCostoNivel2Info || '--'}</Table.Cell>
        <Table.Cell align='center'>{row.cuentaDestinoInfo || '--'}</Table.Cell>
        <Table.Cell>
          <Table.Dropdown>
            {({ handleClose }) => [
              <Table.Dropdown.Item
                key='eliminar'
                handleClose={handleClose}
                onClick={e => clickEliminar({ _idFila: row._idFila })}
              >
                Eliminar
              </Table.Dropdown.Item>
            ]}
          </Table.Dropdown>
        </Table.Cell>
      </Table.Row>
    ),
    [iOrigen, clickEliminar]
  )

  return (
    <Table
      containerId='container-detallesnuevoasiento'
      filas={detalles}
      tablaDetalle
      headRows={tableHeaderRows}
      rowTemplate={tableRowTemplate}
    />
  )
}

export default React.memo(DetalleTablaSection)
